/* Shared Ajax Cart API helpers used across the storefront. */
window.ChaiCart = (function () {
  function refreshBadge() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Two badges now exist — the desktop one (#CartCount, inside
           .site-nav__links) and the mobile-only one (#CartCountMobile, kept
           outside it so it stays visible under the hamburger breakpoint).
           Update both by their shared .site-nav__cart-count class instead of
           a single hardcoded id. */
        var badges = document.querySelectorAll('.site-nav__cart-count');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.hidden = cart.item_count === 0;
        });
      });
  }

  function add(variantId, quantity, sellingPlanId) {
    var body = { id: variantId, quantity: quantity || 1 };
    if (sellingPlanId) body.selling_plan = sellingPlanId;
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (result) {
        refreshBadge();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        return result;
      });
  }

  function changeLine(lineKeyOrIndex, quantity) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKeyOrIndex, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (result) {
        refreshBadge();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        return result;
      });
  }

  function changeLineSellingPlan(lineKeyOrIndex, quantity, sellingPlanId) {
    var body = { id: lineKeyOrIndex, quantity: quantity };
    body.selling_plan = sellingPlanId || null;
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function fetchSection(sectionId, url) {
    var target = url || window.routes.cart_url;
    var sep = target.indexOf('?') > -1 ? '&' : '?';
    return fetch(target + sep + 'section_id=' + sectionId, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); });
  }

  document.addEventListener('DOMContentLoaded', refreshBadge);

  return { add: add, changeLine: changeLine, changeLineSellingPlan: changeLineSellingPlan, fetchSection: fetchSection, refreshBadge: refreshBadge };
})();
